import React, { useContext } from 'react';
import AppContext from '../../../../context/AppContext.js';

const MechanicCard = ({ mechanic, onBookClick }) => {
  const { baseUrlForFile } = useContext(AppContext);

  const getImageUrl = (img) => {
    if (!img) return "/default.png";
    return `${baseUrlForFile}/${img}`;
  };

  return (
    <div className={`mechanic-card ${mechanic.status}`}>

      <div className="card-image-wrapper">

        <img
          src={getImageUrl(mechanic.image)}
          alt={mechanic.fullname}
          className="mechanic-image"
        />

        <div className="overlay">
          <div className="overlay-content">

            <span className="mechanic-badge">
              {mechanic.specialization}
            </span>

            <h3 className="mechanic-name">
              {mechanic.fullname}
            </h3>

            <button
              className="book-mechanic-btn"
              onClick={() => onBookClick(mechanic)}
            >
              Book Mechanic
            </button>

          </div>
        </div>

      </div>
    </div>
  );
};

export default MechanicCard;